import { render } from "./SectionAccountSetting.vue?vue&type=template&id=6f3d555a&scoped=true"
import script from "./SectionAccountSetting.vue?vue&type=script&lang=js"
export * from "./SectionAccountSetting.vue?vue&type=script&lang=js"

import "./SectionAccountSetting.vue?vue&type=style&index=0&id=6f3d555a&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3d555a"]])

export default __exports__